<div class="modal-overlay" *ngIf="isOpen" (click)="onOverlayClick($event)">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ modalTitle }}</h2>
      <button
        type="button"
        class="close-button"
        (click)="onClose()"
        [disabled]="isSubmitting || isLoadingLane"
        aria-label="Close"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <form class="modal-form" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div *ngIf="isLoadingLane" class="loading-state">Loading lane...</div>

        <ng-container *ngIf="!isLoadingLane">
          <div class="form-field">
            <label class="field-label">Lane name <span class="required">*</span></label>
            <input
              type="text"
              class="form-input"
              [class.error]="laneNameError"
              [(ngModel)]="laneName"
              name="laneName"
              placeholder="e.g. Lane 4"
              [disabled]="isSubmitting"
            />
            <div class="error-message" *ngIf="laneNameError">{{ laneNameError }}</div>
          </div>

          <div class="form-field" *ngIf="mode === 'edit'">
            <label class="field-label">Status</label>
            <app-simple-dropdown
              [options]="statusOptions"
              [selectedValue]="status"
              [title]="'Select status'"
              [isOpen]="isStatusDropdownOpen"
              [disabled]="isSubmitting"
              (selectionChange)="selectStatus($event)"
              (toggle)="toggleStatusDropdown()"
              (close)="closeStatusDropdown()"
            >
            </app-simple-dropdown>
          </div>

          <div class="lane-section">
            <label class="gate-checkbox">
              <input
                type="checkbox"
                [(ngModel)]="hasCamera"
                name="hasCamera"
                [disabled]="isSubmitting"
              />
              <span>Lane has a camera</span>
            </label>

            <div class="camera-fields" *ngIf="hasCamera">
              <div class="form-field">
                <label class="field-label">Status</label>
                <app-simple-dropdown
                  [options]="statusOptions"
                  [selectedValue]="cameraStatus"
                  [title]="'Select status'"
                  [isOpen]="isCameraStatusDropdownOpen"
                  [disabled]="isSubmitting"
                  (selectionChange)="selectCameraStatus($event)"
                  (toggle)="toggleCameraStatusDropdown()"
                  (close)="closeCameraStatusDropdown()"
                >
                </app-simple-dropdown>
              </div>

              <div class="form-field">
                <label class="field-label">
                  Serial number <span class="required">*</span>
                  @if (cameraSerialNumber && !isCheckingCameraConnection) {
                    <span class="connection-status-inline">
                      <span
                        class="connection-dot"
                        [class.connected]="isCameraConnected"
                        [class.disconnected]="!isCameraConnected"
                        [title]="
                          isCameraConnected ? 'Device connected via SSE' : 'Device not connected'
                        "
                        aria-label="Camera connection status"
                      >
                      </span>
                      <span class="connection-label">{{
                        isCameraConnected ? 'Connected' : 'Not connected'
                      }}</span>
                    </span>
                  }
                  @if (isCheckingCameraConnection) {
                    <span class="connection-status-inline checking">
                      <span class="checking-spinner"></span>
                      <span class="connection-label">Checking...</span>
                    </span>
                  }
                </label>
                <input
                  type="text"
                  class="form-input"
                  [class.error]="cameraSerialError"
                  [(ngModel)]="cameraSerialNumber"
                  (ngModelChange)="onCameraSerialChange()"
                  name="cameraSerialNumber"
                  placeholder="e.g. E827252CF9B1"
                  [disabled]="isSubmitting"
                />
                <div class="error-message" *ngIf="cameraSerialError">{{ cameraSerialError }}</div>
              </div>

              <div class="form-field">
                <label class="field-label">Model</label>
                <input
                  type="text"
                  class="form-input"
                  [(ngModel)]="cameraModel"
                  name="cameraModel"
                  placeholder="e.g. P1487"
                  [disabled]="isSubmitting"
                />
              </div>

              <div class="form-field">
                <div class="zone-options">
                  <label class="zone-radio">
                    <input
                      type="radio"
                      name="zone"
                      value="type_1"
                      [(ngModel)]="zone"
                      [disabled]="isSubmitting"
                    />
                    ROI 1
                  </label>
                  <label class="zone-radio">
                    <input
                      type="radio"
                      name="zone"
                      value="type_2"
                      [(ngModel)]="zone"
                      [disabled]="isSubmitting"
                    />
                    ROI 2
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="lane-section">
            <label class="gate-checkbox">
              <input
                type="checkbox"
                [(ngModel)]="hasGate"
                name="hasGate"
                [disabled]="isSubmitting"
              />
              <span>Lane has a gate</span>
            </label>

            <div class="gate-fields" *ngIf="hasGate">
              <div class="form-field">
                <label class="field-label">Type <span class="required">*</span></label>
                <app-simple-dropdown
                  [options]="gateTypeOptions"
                  [selectedValue]="laneType"
                  [title]="'Select type'"
                  [isOpen]="isGateTypeDropdownOpen"
                  [disabled]="isSubmitting"
                  (selectionChange)="selectGateType($event)"
                  (toggle)="toggleGateTypeDropdown()"
                  (close)="closeGateTypeDropdown()"
                >
                </app-simple-dropdown>
                <p class="helper-text">{{ laneTypeHelperText }}</p>
              </div>

              <div class="gate-hardware">
                <div class="form-field">
                  <label class="field-label">
                    Serial number <span class="required">*</span>
                    @if (gateSerialNumber && !isCheckingGateConnection) {
                      <span class="connection-status-inline">
                        <span
                          class="connection-dot"
                          [class.connected]="isGateConnected"
                          [class.disconnected]="!isGateConnected"
                          [title]="
                            isGateConnected ? 'Device connected via SSE' : 'Device not connected'
                          "
                          aria-label="Gate connection status"
                        >
                        </span>
                        <span class="connection-label">{{
                          isGateConnected ? 'Connected' : 'Not connected'
                        }}</span>
                      </span>
                    }
                    @if (isCheckingGateConnection) {
                      <span class="connection-status-inline checking">
                        <span class="checking-spinner"></span>
                        <span class="connection-label">Checking...</span>
                      </span>
                    }
                  </label>
                  <input
                    type="text"
                    class="form-input"
                    [class.error]="gateSerialError"
                    [(ngModel)]="gateSerialNumber"
                    (ngModelChange)="onGateSerialChange()"
                    name="gateSerialNumber"
                    placeholder="e.g. E827252CF9B1"
                    [disabled]="isSubmitting"
                  />
                  <div class="error-message" *ngIf="gateSerialError">{{ gateSerialError }}</div>
                </div>

                <div class="form-field">
                  <label class="field-label">Model</label>
                  <input
                    type="text"
                    class="form-input"
                    [(ngModel)]="gateModel"
                    name="gateModel"
                    placeholder="e.g. A9210"
                    [disabled]="isSubmitting"
                  />
                </div>

                <div class="form-field">
                  <label class="field-label" for="gateRelay"
                    >Open relay port <span class="required">*</span></label
                  >
                  <input
                    id="gateRelay"
                    type="text"
                    inputmode="numeric"
                    maxlength="3"
                    class="form-input port-input"
                    [class.error]="gateRelayError"
                    [(ngModel)]="gateRelay"
                    (ngModelChange)="onRelayChange()"
                    name="gateRelay"
                    placeholder="1"
                    [disabled]="isSubmitting"
                  />
                  <p class="helper-text">
                    Port number on the gate controller. The A9210's own relay is port 1.
                  </p>
                  <div class="error-message" *ngIf="gateRelayError">{{ gateRelayError }}</div>
                </div>

                <div class="close-gate">
                  <label class="gate-checkbox">
                    <input
                      type="checkbox"
                      [(ngModel)]="closeGateEnabled"
                      (ngModelChange)="onCloseGateEnabledChange()"
                      name="closeGateEnabled"
                      [disabled]="isSubmitting"
                    />
                    <span>Enable closing gate</span>
                  </label>
                  <p class="helper-text">
                    Adds a Close gate button for this lane. The attendant closes the gate manually;
                    it is never closed automatically.
                  </p>

                  @if (closeGateEnabled) {
                    <div class="form-field">
                      <label class="field-label" for="gateCloseRelay"
                        >Close relay port <span class="required">*</span></label
                      >
                      <input
                        id="gateCloseRelay"
                        type="text"
                        inputmode="numeric"
                        maxlength="3"
                        class="form-input port-input"
                        [class.error]="gateCloseRelayError"
                        [(ngModel)]="gateCloseRelay"
                        (ngModelChange)="onCloseRelayChange()"
                        name="gateCloseRelay"
                        placeholder="20"
                        [disabled]="isSubmitting"
                      />
                      <p class="helper-text">
                        Relays on an A9910 expansion module use higher port numbers. Check the
                        relay's Toggle port URL on the A9210 if unsure.
                      </p>
                      <div class="error-message" *ngIf="gateCloseRelayError">
                        {{ gateCloseRelayError }}
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div class="form-field" *ngIf="laneType === 'automatic'">
                <label class="field-label">Transaction Type</label>
                <app-wi-multi-select
                  appearance="form"
                  [options]="transactionTypeOptions"
                  [selectedIds]="transactionTypeIds"
                  placeholder="All"
                  [multipleSelectionText]="transactionTypeTriggerText"
                  [showTags]="false"
                  [error]="!!transactionTypeError"
                  (selectedIdsChange)="onTransactionTypesChange($event)"
                >
                </app-wi-multi-select>
                <p class="helper-text">
                  The gate automatically opens for the selected payment types. Uncheck Cash to keep
                  the gate closed for cash customers. Card Payment includes card, tap to pay, and
                  terminal — those cannot be filtered separately.
                </p>
                <div class="error-message" *ngIf="transactionTypeError">
                  {{ transactionTypeError }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn-cancel"
          (click)="onClose()"
          [disabled]="isSubmitting || isLoadingLane"
        >
          Cancel
        </button>
        <button type="submit" class="btn-save" [disabled]="isSubmitting || isLoadingLane">
          {{ submitLabel }}
        </button>
      </div>
    </form>
  </div>
</div>
